var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Book',{attrs:{"title":"Livre des bijoux et métaux précieux","type":"police"}})}
var staticRenderFns = []

export { render, staticRenderFns }